import { GoogleMap, Marker, MarkerClusterer } from '@react-google-maps/api';
import { defaultMarker, markerClusterer, selectedMarker } from 'assets';
import { useLocation } from 'contexts/LocationContext';
import { Location } from 'types';

type MarkerMapProps = {
  mapCenter: { lat: number; lng: number };
  mapZoom: number;
  locations: Location[];
};

export default function MarkerMap({
  mapCenter,
  mapZoom,
  locations
}: MarkerMapProps) {
  const [location, setLocation] = useLocation();

  return (
    <div className="absolute top-0 right-0 bottom-0 left-0 hidden sm:block h-full w-full">
      <GoogleMap
        mapContainerClassName="map-container"
        options={{
          fullscreenControl: false,
          streetViewControl: false,
          mapTypeControl: false,
          zoomControlOptions: {
            position: 3
          }
        }}
        center={mapCenter}
        zoom={mapZoom}
        id="act-dashboard-google-map-marker"
      >
        <MarkerClusterer
          styles={[
            {
              url: markerClusterer,
              height: 45,
              width: 45,
              textColor: 'white'
            }
          ]}
        >
          {(clusterer) => (
            <div>
              {locations.map((item) => (
                <Marker
                  key={item.location}
                  position={{
                    lat: item.latitude,
                    lng: item.longitude
                  }}
                  icon={
                    location?.location === item.location
                      ? { url: selectedMarker }
                      : { url: defaultMarker }
                  }
                  onClick={() => setLocation(item)}
                  clusterer={clusterer}
                />
              ))}
            </div>
          )}
        </MarkerClusterer>
      </GoogleMap>
    </div>
  );
}
